'use strict';

require('es6-object-assign/auto'); // Copying objects is useful, but IE11/PhantomJS don't support ES6

/**
* Controller for user & company administration
* @memberOf components.admin
* @namespace adminController
*/

adminController.$inject = ['connectionsFactory', '$state', 'data_project_constants', '$q']

function adminController(connectionsFactory, $state, data_project_constants, $q) {
    var vm = this;

    vm.handleCheckboxCheck = function (event, key, storageObj) {
        storageObj[key] = event.target.checked;
    }

    vm.convertToTitleCase = function (camelCaseStr) {
        return camelCaseStr.replace(/([A-Z])/g, function (match) { return " " + match; })
            .replace(/^./, function (match) { return match.toUpperCase(); }).trim();
    }

    vm.convertToCamelCase = function (titleCaseStr) {
        var camelCaseStr = "";
        titleCaseStr.trim().replace(/\s+/g, ' ').split(' ').forEach(function (word) { camelCaseStr += word[0].toUpperCase() + word.slice(1); });
        return camelCaseStr[0].toLowerCase() + camelCaseStr.slice(1);
    }

    vm.setPermissionsCheckboxes = function (permissionsCheckboxesObj, accountPermissionsObj) {
        if (!permissionsCheckboxesObj || !accountPermissionsObj) return;

        var modules = Object.keys(accountPermissionsObj);
        for (var i = 0; i < modules.length; i++) {
            var modulePermissions = accountPermissionsObj[modules[i]];
            permissionsCheckboxesObj["Download"] = typeof modulePermissions["ExcelDownload"] !== 'undefined' ? modulePermissions["ExcelDownload"] : permissionsCheckboxesObj["Download"];
            permissionsCheckboxesObj[vm.convertToTitleCase(modules[i])] = modulePermissions["DataView"];
        }
    }

    vm.setQueryDefaultsTextboxes = function (queryDefaultsTextboxesObj, accountQueryDefaultsObj) {
        queryDefaultsTextboxesObj.states = null;
        queryDefaultsTextboxesObj.propertyType = null;
        if (!accountQueryDefaultsObj || !accountQueryDefaultsObj.filters) return;
        if (!accountQueryDefaultsObj.filters.location || !accountQueryDefaultsObj.filters.location) return;
        var queryDefaultsObj = JSON.parse(JSON.stringify(accountQueryDefaultsObj));
        queryDefaultsTextboxesObj.states = queryDefaultsObj.filters.location.states;
        queryDefaultsTextboxesObj.propertyType = queryDefaultsObj.filters.property.propTypeM;
    }

    vm.readPermissionsCheckboxesBeforePUTorPOST = function (permissionsCheckboxesObj, accountPermissionsObj) {
        if (!permissionsCheckboxesObj || !accountPermissionsObj) return;

        var modules = Object.keys(permissionsCheckboxesObj);
        for (var i = 0; i < modules.length; i++) {
            var moduleKey = vm.convertToCamelCase(modules[i]);
            if (!accountPermissionsObj[moduleKey]) continue;
            accountPermissionsObj[moduleKey]["DataView"] = permissionsCheckboxesObj[modules[i]];
            if (typeof accountPermissionsObj[moduleKey]["ExcelDownload"] !== 'undefined') accountPermissionsObj[moduleKey]["ExcelDownload"] = permissionsCheckboxesObj["Download"];
        }
    }

    vm.readQueryDefaultsTextboxesBeforePUTorPOST = function (queryDefaultsTextboxesObj, accountQueryDefaultsObj) {
        if (!accountQueryDefaultsObj) accountQueryDefaultsObj = { filters: {} };
        accountQueryDefaultsObj.filters.location = { states: null };
        accountQueryDefaultsObj.filters.property = { propTypeM: null };
        if (!queryDefaultsTextboxesObj) return;
        var textboxesObj = JSON.parse(JSON.stringify(queryDefaultsTextboxesObj));
        accountQueryDefaultsObj.filters.location.states = textboxesObj.states;
        accountQueryDefaultsObj.filters.property.propTypeM = textboxesObj.propertyType;
    }

    vm.getBaseAccount = function (labelProperty, accounts) {
        var selector = {};
        if (labelProperty == "name") selector = { name: "<base-company>" };
        if (labelProperty == "username") selector = { username: "<base-user>" };
        var baseAccount = _.find(accounts, selector);
        return baseAccount ? baseAccount : {};
    }

    vm.apiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.application_api);
    vm.referenceApiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.reference_api);
    vm.awardApiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.award_api);

    // TODO(breilly, 2018-08-10): I don't love this. Creating a class like this makes it feel like it should be a
    // controller, which means it could be a directive instead. But since the contents of the UI differs between users
    // and companies, we'd have to create a transcluded controller. That would force us to do something like...
    //
    // <acct-mgr ...>
    //   <h1>{{$parent.accountType}} Management</h1>
    // </acct-mgr>
    //
    // Notice the use of $parent to access the directive's controller (this is the correct and necessary syntax). Not
    // a big fan of that either. Hopefully as time goes on it'll become more clear how best to handle this shared code
    // and UI.
    //
    // In the meantime, I don't want to abstract too early; see...
    // https://www.sandimetz.com/blog/2016/1/20/the-wrong-abstraction
    vm.createAccountManager = function (accountType) {
        var manager = {
            accounts: [],
            permissionsCheckboxes: {},
            queryDefaultsTextboxes: {}
        };

        manager.getAccountList = function () {
            return vm.apiConnection.all(accountType).customGET('')
                .then(function (response) {
                    manager.accounts = response.plain()[accountType];
                })
                .then(function () {
                    // NOTE(breilly, 2018-10-08): Only users use the create mode at the moment, but that'll change
                    // soon, so I don't mind letting that spill into the shared code right now.
                    if (!manager.createMode) {
                        manager.onSelectAccount();
                    }
                });
        };

        manager.onSelectAccount = function () {
            manager.editedAccount = null;
            manager.status = null;

            if (!manager.selectedId) return;

            var matchingAccount = _.find(manager.accounts, { id: manager.selectedId });

            if (!matchingAccount) return;

            vm.setPermissionsCheckboxes(manager.permissionsCheckboxes, matchingAccount.permissions);
            if (accountType == 'companies') vm.setQueryDefaultsTextboxes(manager.queryDefaultsTextboxes, matchingAccount.queryDefaults);

            manager.editedAccount = Object.assign({}, matchingAccount);
        };

        manager.toggleField = function (fieldName) {
            manager.editedAccount[fieldName] = !manager.editedAccount[fieldName];
        };

        manager.setStatus = function (isProcessing, isError, message) {
            manager.status = {
                isProcessing: isProcessing,
                isError: isError,
                message: message
            };
        };

        manager.omitNonUpdatableAccountFields = function(account) {
            var modifiedAccount;

            if (accountType == 'users') {
                modifiedAccount = _.omit(account, ['dateCreated', 'origin.dateStatusChanged', 'vision.dateStatusChanged']);
            }
            else if (accountType == 'companies') {
                modifiedAccount = _.omit(account, ['dateCreated', 'origin.dateStatusChanged', 'vision.dateStatusChanged', 'vision.restrictions']);
            }

            return modifiedAccount;
        }

        manager.update = function () {
            manager.setStatus(true, false, 'Processing...');

            if (manager.editedAccount) vm.readPermissionsCheckboxesBeforePUTorPOST(manager.permissionsCheckboxes, manager.editedAccount.permissions);
            if (manager.editedAccount && accountType == 'companies') vm.readQueryDefaultsTextboxesBeforePUTorPOST(manager.queryDefaultsTextboxes, manager.editedAccount.queryDefaults);

            var deferred = $q.defer();

            vm.apiConnection
                .one(accountType, manager.selectedId)
                .customPUT(manager.omitNonUpdatableAccountFields(manager.editedAccount), undefined, undefined, { 'Content-Type': 'application/json' })
                .then(function (data) {
                    manager.getAccountList()
                        .then(function () {
                            manager.setStatus(false, false, 'Update succeeded');

                            deferred.resolve();
                        },
                        function (result) {
                            // No longer authorized (probably because you disabled yourself or your company)
                            if (result.status == 401) {
                                $state.go('authentication.logout');
                                return;
                            }
                        });
                },
                function (result) {
                    if (result.status == 401) {
                        $state.go('authentication.logout');
                        return;
                    }

                    manager.getAccountList().then(function () {
                        manager.setStatus(false, true, 'Updated failed: ' + result.data.message);
                    });
                });

            return deferred.promise;
        };

        manager.createAccountSkeleton = function (labelProperty, baseAccount) {
            var skeletons = {
                "username": {
                    isEnabled: true,
                    vision: { status: "Inactive" },
                    origin: { status: "Inactive" },
                    permissions: baseAccount.permissions,
                    queryDefaults: baseAccount.queryDefaults ? baseAccount.queryDefaults : { filters: { location: { states: [] }, property: { propTypeM: null } } }
                },
                "name": {
                    isEnabled: true,
                    vision: {
                        status: 'Inactive',
                        billing: 'Subscription'
                    },
                    origin: {
                        status: 'Inactive',
                        billing: 'Subscription',
                        customerType: 'Market',
                        reportType: 'Market'
                    },
                    permissions: baseAccount.permissions,
                    queryDefaults: baseAccount.queryDefaults ? baseAccount.queryDefaults : { filters: { location: { states: [] }, property: { propTypeM: null } } }
                }
            };
            return skeletons[labelProperty];
        };

        manager.enableCreateMode = function () {
            if (manager.createMode) return;

            manager.createMode = true;
            manager.selectedId = -1;
            manager.status = null;

            var baseAccount = vm.getBaseAccount(manager.labelProperty, manager.accounts);

            manager.editedAccount = manager.createAccountSkeleton(manager.labelProperty, baseAccount);

            vm.setPermissionsCheckboxes(manager.permissionsCheckboxes, baseAccount.permissions);
            vm.setQueryDefaultsTextboxes(manager.queryDefaultsTextboxes, baseAccount.queryDefaults);
        };

        manager.disableCreateMode = function () {
            if (!manager.createMode) return;

            manager.createMode = false;
            manager.selectedId = null;
            manager.editedAccount = null;
        };

        manager.create = function () {
            manager.setStatus(true, false, 'Processing...');

            if (manager.editedAccount) vm.readPermissionsCheckboxesBeforePUTorPOST(manager.permissionsCheckboxes, manager.editedAccount.permissions);
            if (manager.editedAccount && accountType == 'companies') vm.readQueryDefaultsTextboxesBeforePUTorPOST(manager.queryDefaultsTextboxes, manager.editedAccount.queryDefaults);

            var deferred = $q.defer();

            vm.apiConnection
                .all(accountType)
                .customPOST(manager.editedAccount, undefined, undefined, { 'Content-Type': 'application/json' })
                .then(function (data) {
                    manager.getAccountList()
                        .then(function () {
                            manager.setStatus(false, false, 'Create \'' + manager.editedAccount[manager.labelProperty] + '\' succeeded');
                            manager.disableCreateMode();
                            manager.selectedId = data.id;

                            deferred.resolve();
                        },
                        function (result) {
                            // No longer authorized (probably because you disabled yourself or your company)
                            if (result.status == 401) {
                                $state.go('authentication.logout');
                                return;
                            }
                        });
                },
                function (result) {
                    if (result.status == 401) {
                        $state.go('authentication.logout');
                        return;
                    }

                    manager.setStatus(false, true, 'Create failed: ' + result.data.message);
                });

            return deferred.promise;
        };

        manager.init = function () {
            manager.getAccountList();
            manager.selectedId = null;
            manager.queryDefaultsTextboxes = {
                propertyType: null,
                states: null
            };
        };

        return manager;
    };

    vm.getResource = function (resource) {
        return vm.apiConnection
            .all(resource)
            .customGET()
            .then(function (result) {
                vm[resource] = result.plain()[resource];
            });
    };

    vm.getReferenceResource = function (resource) {
        if (vm.referenceResources === undefined) vm.referenceResources = {};
        return vm.referenceApiConnection
            .all(resource)
            .customGET()
            .then(function (result) {
                vm.referenceResources[resource] = result.plain()[resource];
            });
    }

    vm.resetOktaIdInputField = function () {
        vm.userManager.editedAccount.oktaId = "";
    }

    vm.configureUserManager = function () {
        vm.userManager = vm.createAccountManager('users');
        vm.userManager.labelProperty = 'username';

        var originalOnSelectAccount = vm.userManager.onSelectAccount;

        vm.userManager.onSelectAccount = function () {
            originalOnSelectAccount();

            if (!vm.userManager.selectedId) return;

            var matchingAccount = vm.userManager.accounts.find(function (x) { return x.id == vm.userManager.selectedId; });

            if (!matchingAccount || !matchingAccount.defaultPerformanceMonitorQueryId) return;  //_.find(vm.userManager.accounts, { id: vm.userManager.selectedId });

            // There is a default report for each module but the default values for state / propTypeM 
            // should be the same for all because the were created with the same values and saved reports cannot currently be updated 
            // So we are just loading the values from the default Performance Monitor report
            vm.awardApiConnection
                .all('savedreports/' + matchingAccount.defaultPerformanceMonitorQueryId)
                .customGET()
                .then(function (defaultQuery) {
                    vm.setQueryDefaultsTextboxes(vm.userManager.queryDefaultsTextboxes, defaultQuery.savedReport.queryParameters);
                });
        }

        var originalCreate = vm.userManager.create;

        vm.userManager.create = function () {
            originalCreate().then(function () {
                var defaultParameters = { filters: { location: { states: null }, property: { propTypeM: null } } };
                vm.readQueryDefaultsTextboxesBeforePUTorPOST(vm.userManager.queryDefaultsTextboxes, defaultParameters);

                vm.awardApiConnection
                    .all('savedreports/default/' + vm.userManager.selectedId, undefined, undefined, { 'Content-Type': 'application/json' })
                    .customPUT(defaultParameters)
                    .then(function (response) {
                        vm.userManager.getAccountList().then(function () {
                            vm.userManager.setStatus(false, false, 'Create user default reports succeeded');
                            vm.userManager.disableCreateMode();
                        },
                            function (result) {
                                // No longer authorized (probably because you disabled yourself or your company)
                                if (result.status == 401) {
                                    $state.go('authentication.logout');
                                    return;
                                }
                            });
                    }),
                    function (result) {
                        vm.userManager.getAccountList().then(function () {
                            vm.userManager.setStatus(false, true, 'Updated failed: ' + result.data.message);
                        });
                    };
            });
        }

        var originalUpdate = vm.userManager.update;

        vm.userManager.update = function () {
            originalUpdate().then(function () {
                var defaultParameters = { filters: { location: { states: null }, property: { propTypeM: null } } };
                vm.readQueryDefaultsTextboxesBeforePUTorPOST(vm.userManager.queryDefaultsTextboxes, defaultParameters);

                vm.awardApiConnection
                    .all('savedreports/default/' + vm.userManager.selectedId, undefined, undefined, { 'Content-Type': 'application/json' })
                    .customPUT(defaultParameters)
                    .then(function (response) {
                        vm.userManager.getAccountList().then(function () {
                            vm.userManager.setStatus(false, false, 'Update user default reports succeeded');
                        },
                            function (result) {
                                // No longer authorized (probably because you disabled yourself or your company)
                                if (result.status == 401) {
                                    $state.go('authentication.logout');
                                    return;
                                }
                            });
                    }),
                    function (result) {
                        vm.userManager.getAccountList().then(function () {
                            vm.userManager.setStatus(false, true, 'Updated failed: ' + result.data.message);
                        });
                    };
            });
        }

        vm.userManager.init();
    }

    vm.configureCompanyManager = function () {
        vm.companyManager = vm.createAccountManager('companies');
        vm.companyManager.labelProperty = 'name';

        // TODO(jjones, 2018-08-29): Come up with a better way to handle the differences and similarities between users and companies.
        var originalOnSelectAccount = vm.companyManager.onSelectAccount;

        vm.companyManager.onSelectAccount = function () {
            originalOnSelectAccount();

            // Handle the resetting of the display lenders then add any lenders that the company may have in their Origin restrictions.
            vm.displayLenders = vm.lenders;

            var restrictions = vm.companyManager.editedAccount ? vm.companyManager.editedAccount.origin.restrictions : null;

            if (restrictions && restrictions.lenders.length) {
                var knownLenderIds = _.map(vm.lenders, 'id');
                var unknownLenderIds = _.difference(restrictions.lenders, knownLenderIds);

                var unknownLenders = unknownLenderIds.map(function (id) {
                    return { id: id, name: 'unknown lender: ' + id };
                });

                vm.displayLenders = vm.displayLenders.concat(unknownLenders);
            }
        }

        var originalCompanyUpdate = vm.companyManager.update;

        // TODO(jjones, 2018-09-06): Come up with a better way to handle this
        vm.companyManager.update = function () {
            var reportType = vm.companyManager.editedAccount.origin.reportType;

            if (reportType != 'Lender') {
                vm.companyManager.editedAccount.origin.restrictions.lenders = [];
            }

            if (reportType != 'Vendor') {
                vm.companyManager.editedAccount.origin.restrictions.vendorAddresses = [];
                vm.companyManager.editedAccount.origin.restrictions.vendorDomains = [];
            }

            originalCompanyUpdate();
        }

        var originalCompanyCreate = vm.companyManager.create;

        vm.companyManager.create = function () {
            originalCompanyCreate().then(function () {
                vm.companyManager.selectedId = null;
            });
        }

        vm.companyManager.init();
    }

    vm.$onInit = function () {
        
        vm.configureUserManager();
        vm.configureCompanyManager();        

        vm.getResource('statuses');
        vm.getResource('billingTypes');
        vm.getResource('customerTypes');
        vm.getResource('reportTypes');
        vm.getResource('lenders').then(function () {
            vm.displaylenders = vm.lenders
        });
        vm.getReferenceResource('states');
        vm.getReferenceResource('propertyTypes').then(function () {
            vm.referenceResources.propertyTypes.unshift({ id: null, name: "Select a Property Types" });
        });
    };
}

module.exports = adminController;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/adminController.js
// module id = 32
// module chunks = 0